import { API_AUTH_BASE, API_PATH_AUTH_REFRESH } from '@/features/auth/constants';
import { getStorage } from '@/shared/hooks/use-storage';

export type AuthRefreshTokenData = {
  refreshToken: string;
};

export type AuthRefreshTokenPayload = {
  user?: string;
  accessToken: string;
};

export const authRefreshToken = async (data: AuthRefreshTokenData) => {
  const { store } = getStorage();

  return fetch(API_AUTH_BASE + API_PATH_AUTH_REFRESH, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then(async (res) => {
    const { ...auth } = await store.getAuth();
    const resJson = await res.json();
    await store.setAuth({
      ...auth,
      refreshToken: data.refreshToken,
      accessToken: resJson.accessToken,
      updatedAt: Date.now(),
    });
    return res;
  });
};
